import { AlertsEffects } from './alerts.effect';

export const effects: any[] = [AlertsEffects];

export * from './alerts.effect';
